import orderIndex from '@/pages/order/index.vue'
import orderList from '@/pages/order/orderList.vue'
import orderDetail from '@/pages/order/orderDetail.vue'

const appRoutes = [{
	path: '/order',
	redirect: '/order/orderList',
	component: orderIndex,
	children: [{
		path: 'orderList',
    name: 'orderList',
		component: orderList
	},{
		path: 'orderDetail',
    name: 'orderDetail',
		component: orderDetail
	}]
}]
export default appRoutes
